var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thumb overflow-hidden me-2",style:({ backgroundColor: _vm.assistant.hexcolor || '#fff' })},[(!_vm.assistant.hexcolor || _vm.assistant.hexcolor == 'null')?_c('img',{attrs:{"src":_vm.assistant.profile_pic_small || _vm.assistantThumbPlaceholder,"alt":""}}):_c('div',[_vm._v(_vm._s(_vm.assistant.name.substr(0, 1)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }